import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import {
  HrParagraph,
  HrFlexContainer,
  HrTitleContainer,
  HrTitleH4,
  HrButtons,
  HrPrimary,
  HrWhite
} from '@components/styles/hr-styles';
import { Input } from '@components/form/input';
import { HrButton } from '@components/button/button';
import { SelectForm } from '@components/form/select';
import { Textarea } from '@components/form/textarea';
import { Modal } from '../modal';
import { sendSupport } from '../../services/api';
import useStore from '../../store/useStore';
import { supportModal } from '../../../constant/vacancy';
import { DisplaySettingsContext } from '../../store/display-settings';

export const ModalSupport = ({
  setShowModalSuport,
  setShowModalFaqs,
  onShowToast,
  formState,
  getValues,
  cloudflareRecaptcha
}) => {
  const { vacancy } = useStore();
  const [t] = useTranslation();
  const [load, setLoad] = useState(false);

  const {
    handleSubmit: handleSubmitSupport,
    register: registerSupport,
    formState: formStateSupport,
    control: controlSupport
  } = useForm({
    mode: 'all'
  });

  const _handleSubmitSupport = (data) => {
    setLoad(true);
    let bodyError = '';
    // eslint-disable-next-line no-restricted-syntax
    const _data = getValues();

    try {
      const { errors = {} } = formState;
      if (!!errors && typeof errors === 'object' && Object.keys(errors).length > 0) {
        bodyError += `<p><b>Form errors (${typeof errors})</b></p>`;
        bodyError += '<table><tr><th>Campo</th><th>Mensaje</th><th>Valor</th></tr>';
        for (const prop in errors) {
          const errorMessage = errors[prop].message
            ? errors[prop].message
            : JSON.stringify(errors[prop]);
          const inputValue = _data[prop] ? JSON.stringify(_data[prop]) : '';

          bodyError += `<tr><td>${prop}</td><td>${errorMessage}</td><td>${inputValue}</td></tr>`;
        }
        bodyError += '</table>';
      } else {
        bodyError += `<p>${JSON.stringify(errors)}</p>`;
      }
    } catch (e) {
      bodyError += `<p style="padding:0; margin:0;">Errores de formulario no reportados. Exception ${e}</p>`;
    }

    try {
      if (sessionStorage.getItem('errorPage')) {
        const _errors = JSON.parse(sessionStorage.getItem('errorPage'));

        if (!!_errors && typeof _errors === 'object' && Object.keys(_errors).length > 0) {
          bodyError += `<p><b>ErrorPage (${typeof _errors})</b></p>`;
          bodyError += '<table><tr><th>Campo</th><th>Mensaje</th><th>Valor</th></tr>';
          for (const pro in _errors) {
            bodyError += `<tr><td>${pro}</td><td>${_errors[pro]}</td><td>${_data[pro]}</td></tr>`;
          }
          bodyError += '</table>';
        } else {
          bodyError += `<p>${JSON.stringify(_errors)}</p>`;
        }
      }
    } catch (e) {
      bodyError += `<p style="padding:0; margin:0;">Errores de página no reportados. Exception ${e}</p>`;
    }

    try {
      if (sessionStorage.getItem('ErrorBack')) {
        bodyError += `<p><b>ErrorBack (${sessionStorage.getItem('ErrorBack')})</b></p>`;
      }
    } catch (e) {
      bodyError += `<p style="padding:0; margin:0;">Errores de página no reportados. Exception ${e}</p>`;
    }
    try {
      if (sessionStorage.getItem('keyErrorBack')) {
        bodyError += `<p><b>KeyErrorBack (${sessionStorage.getItem('keyErrorBack')})</b></p>`;
      }
    } catch (e) {
      bodyError += `<p style="padding:0; margin:0;">Errores de página no reportados. Exception ${e}</p>`;
    }

    const cc = `
      <p>${data.description}</p>
      <p><strong>Datos inválidos en el formulario:</strong> ${bodyError}</p>
      <p>
        <strong>apply:</strong> ${_data.apply_with || 0} <br />
        <strong>navigator:</strong> ${JSON.stringify(navigator.userAgent)}
      </p>

      ${
        cloudflareRecaptcha
          ? `<p><strong>Turnstile funciona?</strong> ${
              getValues('cloudflare_recaptcha_token') ? 'Sí' : 'No'
            }</p>`
          : ''
      }
    `;

    const prom = sendSupport(data.user, data.mail, data.cc, cc, vacancy.shorturl, vacancy.account);
    prom
      .then((res) => {
        const { success } = res.data;
        if (success) {
          onShowToast({ visible: true, message: t('postulant.toast.support_success') });
          setLoad(false);
          setShowModalSuport(false);
        }
      })
      .catch((error) => {
        onShowToast({ visible: true, type: 'error', message: t('general.error.supportInput') });
        setLoad(false);
      });
  };

  const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

  return (
    <Modal setShowModal={setShowModalSuport}>
      <HrTitleContainer padding='32px 24px 16px 24px' gap='4px'>
        <span style={{ color: darkMode ? 'white' : '' }} className='hr-Settings' />
        <HrTitleH4 fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''}>
          {t('postulant.modal.support.title')}
        </HrTitleH4>
      </HrTitleContainer>
      <HrFlexContainer flexDirection='column' padding='24px'>
        <HrParagraph fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''}>
          {t('postulant.modal.support.text')}
        </HrParagraph>
        <HrFlexContainer flexDirection='column'>
          <Input
            title={t('postulant.firstname')}
            placeholder={t('postulant.placeholder.firstname')}
            name='user'
            type='text'
            register={registerSupport}
            formState={formStateSupport}
            validate={{
              required: true
            }}
          />
          <Input
            title={t('postulant.mail')}
            placeholder={t('postulant.placeholder.mail')}
            name='mail'
            type='text'
            register={registerSupport}
            formState={formStateSupport}
            validate={{
              required: true,
              mail: true
            }}
          />

          <SelectForm
            title={t('postulant.cc')}
            placeholder={t('postulant.placeholder.cc')}
            id='cc'
            data={supportModal}
            control={controlSupport}
            formState={formStateSupport}
            validate={{ required: true }}
          />

          <Textarea
            title={t('postulant.description')}
            placeholder={t('postulant.placeholder.description')}
            id='description'
            control={controlSupport}
            formState={formStateSupport}
            minHeight='105px'
            validate={{
              required: true
            }}
          />
        </HrFlexContainer>
        <HrFlexContainer justifyContent='space-between'>
          <HrButtons
            type='button'
            category='cancel'
            size='medium'
            style={{ fontSize: `${14 + fontSizeSetting || 0}px` }}
            onClick={() => {
              setShowModalSuport(false);
            }}
          >
            {t('general.button.cancel')}
          </HrButtons>
          <HrFlexContainer width='auto' gap='8px'>
            <HrButtons
              type='button'
              style={{ fontSize: `${14 + fontSizeSetting || 0}px` }}
              category={darkMode ? 'tertiaryGreenDark' : 'tertiaryGreen'}
              size='medium'
              onClick={() => {
                setShowModalSuport(false);
                setShowModalFaqs(true);
              }}
            >
              <span style={{ color: HrPrimary }} className='hr-Carret-left' />
              {t('general.button.return')}
            </HrButtons>
            <HrButton
              type='button'
              name='submit'
              category='primary'
              size='medium'
              fontSize={`${14 + fontSizeSetting || 0}px`}
              onClick={handleSubmitSupport(_handleSubmitSupport)}
              text={t('general.button.send')}
              iconColor={HrWhite}
              loading={load}
              disabled={load}
            />
          </HrFlexContainer>
        </HrFlexContainer>
      </HrFlexContainer>
    </Modal>
  );
};
